<template>
    <PageContainer :breadcrumbs="breadcrumbs">
      <Conditions />
    </PageContainer>
</template>

<script lang="ts">
  import { useSeoMeta, definePageMeta, useHead, useRuntimeConfig } from '#imports'
  import { defineNuxtComponent } from '#app'
  import Conditions from '@/components/Pokemon/Conditions'
  import PageContainer from '@/containers/Page'
  
  export default defineNuxtComponent({
    components: {
      Conditions,
      PageContainer,
    },
    async setup() {
      const { public: { APP_ENV } } = useRuntimeConfig()
      const title = 'カードの状態について - カーナベル'
      const description = "カーナベルではS・A・B・Cの4段階に分け、100時間以上もの査定練習を行ったスタッフが線傷・ヘコみ・日焼け跡など、カードの状態を総合的に判断しています"
      useSeoMeta({
        title,
        description,
        ogTitle: title,
        ogDescription: description,
        robots: APP_ENV==='production' ? 'index,follow' :'noindex,nofollow',
        twitterSite: '@ka_nabell_pcg',
        ogSiteName: 'ポケカ販売ならカーナベル！',
        ogUrl: 'https://sell.ka-nabell.com/pokemon/conditions'
      })

      useHead({
        link: [
          {
            rel: 'canonical',
            href: 'https://sell.ka-nabell.com/pokemon/conditions'
          }
        ]
      })
  
      definePageMeta({
        genre: 'pokemon',
        layout: 'default'
      })

      const breadcrumbs = [
        {
          title: 'トレカ販売トップ',
          link: '/',
        },
        {
          title: 'カードの状態について',
        },
      ]

      return {
        breadcrumbs,
      }
    }
  })
</script>
